import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import qs from 'query-string';

import {
    ExportProps,
    ExportsParams,
    ExportsProps,
} from '../interface/exports.interface';
import getEnvConfig from '../../../../../utils/config/env';
import { PaginatedResponse } from '../../../../communities/interfaces/PaginatedResponse';

export const exportsApi = createApi({
    reducerPath: 'exports',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem('accessToken');
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['Exports'],

    endpoints: builder => ({
        createExport: builder.mutation<ExportsProps[], ExportsParams>({
            query: payload => ({
                url: `/exports`,
                method: 'POST',
                body: { ...payload },
            }),
            transformResponse: (response: { data: ExportsProps[] }) => {
                return response.data;
            },
            invalidatesTags: ['Exports'],
        }),

        readExports: builder.query<
            PaginatedResponse<ExportsProps>,
            ExportProps
        >({
            query: params => {
                const queryArgs = qs.stringify(params, {
                    arrayFormat: 'bracket-separator',
                    skipNull: true,
                });
                return {
                    url: `/exports?${queryArgs}`,
                };
            },
            transformResponse: (
                response: { data: ExportsProps[] },
                meta?: { response?: { headers?: Headers } }
            ): PaginatedResponse<ExportsProps> => {
                let total = 0;
                if (meta && meta.response && meta.response.headers) {
                    const count = meta.response.headers.get
                        ? meta.response.headers.get('Items-Count')
                        : null;
                    total = count ? Number(count) : 0;
                }
                return {
                    items: response.data ?? [],
                    total,
                };
            },
            providesTags: ['Exports'],
        }),
    }),
});

export const { useCreateExportMutation, useLazyReadExportsQuery } = exportsApi;
